import { BN } from '@project-serum/anchor'

export const isBN = (number: BN): boolean => BN.isBN(number)

export const convertToBalance = (amount: BN, decimals: number): BN => amount.div(new BN(Math.pow(10, decimals)))

export const gtZero = (amount: BN): boolean => amount.gt(new BN(0))
